export const BAAS_HOME_FIAT_CURRENCIES = ["BRL", "USD", "EUR", "USDC", "USDT"];

/** Mock FX rates — amount in BRL per 1 unit of foreign currency. */
export const BAAS_HOME_FX_RATES_FROM_BRL = {
  BRL: 1,
  USD: 0.183,
  EUR: 0.169,
  USDC: 0.184,
  USDT: 0.184,
};

export const normalizeBaasHomeCurrency = (currency = "BRL") => {
  const normalized = String(currency || "BRL").toUpperCase();
  return BAAS_HOME_FIAT_CURRENCIES.includes(normalized) ? normalized : "BRL";
};

export const convertBaasHomeAmountFromBrl = (amountBrl, currency) => {
  const safeAmount = Number(amountBrl);
  if (!Number.isFinite(safeAmount)) return 0;

  const target = normalizeBaasHomeCurrency(currency);
  const rate = BAAS_HOME_FX_RATES_FROM_BRL[target] ?? 1;
  if (target === "BRL") return safeAmount;

  return safeAmount * rate;
};

export const getBaasHomeCurrencyFilters = (currency, searchQuery = "") => ({
  currencies: [normalizeBaasHomeCurrency(currency)],
  searchQuery,
});
